import { RootState } from "@/app/stores"
import { getDashboardTransactions, IDashboardTransactionsResponse } from "@/shared/api/onboarding"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchLatestTransactions = createAsyncThunk<
    IDashboardTransactionsResponse,
    void,
    { state: RootState }
>('companyTransactionsStatistics/fetchLatestTransactions', async (_, thunkAPI) => {
    try {
        const response = await getDashboardTransactions({
            page: 1,
            limit: 10
        })

        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

